module.exports = __webpack_public_path__ + "media/images/loading-2299ad0b3f63413f026dfec20c205b8f.gif";